import React from "react"
import { Link } from "gatsby"
import IconLocation from "../../assets/svg/location-icon.inline.svg"
import IconPhone from "../../assets/svg/icon-phone.inline.svg"
import IconDMAE from "../../assets/svg/dmae-logo.inline.svg"
import IconLSU from "../../assets/svg/logo-lsu.inline.svg"
import {footer, smallSpace, icon, gray800, headingLight, iconLsu, finePrint, iconDmaelogo} from "./footer.module.scss"
import Container from "../bootstrap/container"
import Row from "../bootstrap/row"
import Col from "../bootstrap/col"
import MailchimpForm from "../../components/shared/mailchimp-form"
import Config from "../../../gatsby-config"

var Year = new Date().getFullYear()

export default function Footer() {
  const description = Config.siteMetadata.description
  const telephone = Config.siteMetadata.telephone

  return (
    <>
      <section id="footer" className={`bg-dark pb-5 pt-4 ${footer}`}>
        <Container>
          <h2 className="visually-hidden"> Footer</h2>
          <Row className="justify-content-center mt-2 mt-md-4">
            <Col md={8} lg={7} xl={6} className="d-none d-md-block mb-5">
              <p className={`text-center text-secondary ${smallSpace}`}>
                <small>{description} </small>
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="auto"></Col>
            <Col xs={9} sm={9} md={3} lg={3} xl={2}>
              <address>
                <div>
                  <p className={`text-secondary mb-1 ${smallSpace}`}>
                    <small className={`fw-bold ${smallSpace}`}>
                      <span> LSU Digital Media Arts &amp; Engineering</span>
                    </small>
                  </p>
                  <div>
                    <p className={`mb-1 ${smallSpace}`}>
                      <a
                        className="text-secondary"
                        href="https://www.google.com/maps/place/Digital+Media+Center/@30.4075301,-91.1721524,17z/data=!4m2!3m1!1s0x8626a6e00af1a36b:0xc0e913a5a5b2ff7a"
                      >
                        <small>
                          <span>Digital Media Center</span>
                          <br className={smallSpace} />
                          <span>340 East Parker Blvd.</span>
                          <br className={smallSpace} />
                          <span> Baton Rouge, </span>
                          <span> LA </span>
                          <IconLocation
                            className={`${icon} ml-1`}
                            viewBox="0 0 32 32"
                          />
                        </small>
                      </a>
                    </p>
                    <p>
                      <a
                        className={`text-secondary ${smallSpace}`}
                        href="tel:+12255788907"
                      >
                        <small>
                          <span className={smallSpace}>{telephone}</span>
                          <span
                            className="glyphicon glyphicon-phone-alt"
                            aria-hidden="true"
                          ></span>
                          <IconPhone
                            className={`${icon} ms-1 mb-1`}
                            viewBox="0 0 32 32"
                          />
                        </small>
                      </a>
                    </p>
                  </div>
                </div>
              </address>
            </Col>
            <Col md="auto"></Col>
            <hr className={`${gray800} d-md-none w-75 pt-3 bg-dark`} />
            <Col xs={9} sm={7} md={4} lg={4}>
              <p className={`h5 text-secondary ${headingLight}`}>
                Sign Up for Newsletter
              </p>

              <MailchimpForm
                inputId="footerEmailInput"
                prependId="footerEmailPrepend"
                messageId="footerInputMessage"
                size="sm"
                variant="secondary"
                labelColor="text-light"
              />
            </Col>

            <Col xs={9} sm={2} md="auto"></Col>
            <hr className={`${gray800} d-md-none w-75 pt-3 bg-dark`} />
            <Col xs={9} sm={9} md={3} lg={3} xl={2}>
              <p className={`h5 text-secondary ${headingLight}`}>
                Links
              </p>
              <ul className="links list-unstyled">
                <li className="mb-0">
                  <a
                    href="https://lsu.edu/"
                    className="text-secondary underline"
                  >
                    <small>LSU</small>
                  </a>
                </li>
                <li className="mb-0">
                  <a
                    href="https://cct.lsu.edu"
                    className="text-secondary underline"
                  >
                    <small>CCT</small>
                  </a>
                </li>
                <li className="mb-0">
                  <a
                    href="/academics-master"
                    className="text-secondary underline"
                  >
                    <small>DMAE Master's Degree</small>
                  </a>
                </li>
                <li className="mb-0">
                  <a
                    href="/academics-minor"
                    className="text-secondary underline"
                  >
                    <small>DMAE Undergraduate Minor</small>
                  </a>
                </li>
                <li className="mb-0">
                  <a
                    href="https://lsu.edu/feedback/"
                    className="text-secondary underline"
                  >
                    <small>Provide Website Feedback</small>
                  </a>
                </li>
                <li className="mb-0">
                  <a
                    href="https://lsu.edu/accessibility/"
                    className="text-secondary underline"
                  >
                    <small>Accessibility Statement</small>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.lsu.edu/privacy/"
                    className="text-secondary underline"
                  >
                    <small>Privacy Statement</small>
                  </a>
                </li>
              </ul>
            </Col>
          </Row>

          <div className="row justify-content-center">
            <div className="col-md-auto"></div>
            <div className="col-9 col-md-3 col-lg-3 col-xl-2  d-none d-md-block">
              <a href="https://lsu.edu/">
                <IconLSU
                  className={`${iconLsu} ml-1`}
                  viewBox="0 0 103 32"
                />
              </a>
            </div>

            <div className="col-md-auto"></div>
            <hr className={`${gray800} d-md-none w-75 pt-3 bg-dark`} />
            <div className="col-9 col-md-4 col-lg-4">
              <p className={`text-secondary text-center ${finePrint}`}>
                <small>
                  {" "}
                  Copyright &copy; {Year} Official Web page of{" "}
                  <a
                    className="text-secondary underline"
                    href="https://lsu.edu/"
                  >
                    Louisiana State University
                  </a>
                </small>
              </p>
            </div>

            <div className="col-md-auto"></div>
            <div className="col-9 col-md-3 col-lg-3 col-xl-2 d-none d-md-block">
              <div className="pl-md-0">
                <Link to="/" className="nav-link p-0" activeClassName="active">
                  <IconDMAE
                    className={`${iconDmaelogo} p-1`}
                    viewBox="0 0 240 32"
                  />
                </Link>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  )
}
